<template>
	<div class="ip fancybox_iframe" :class="{'instashop-gallery': mobileBreakpoint}" @click="instashopOpen(item, index, items)" v-for="(item,index) in items" :key="item.id">
		<span><BaseUiImage :data="item.main_image_thumbs?.['width1000-height1000-crop1']" alt="" default="/images/no-image-1000.jpg" loading="lazy" /></span>
	</div>
</template>

<script setup>
	const {mobileBreakpoint} = inject('rwd');
	const props = defineProps({
		items: {
			type: Object,
			required: true
		}
	})

	const instashopActive = ref(false);
	const instashopItemIndex = ref();
	const instashopItems = ref([]);
	const instashopItemsProducts = ref([]);

	const instashopData = useState(
		'instashopData', () => ({
			instashopActive: false,
			instashopItemIndex: null,
			items: []
		})
	)

	function resetInstashopData() {
		instashopData.value = {
			instashopActive: false,
			instashopItemIndex: null,
			items: [],
			instashopItemsProducts: []
		}
	}

	function instashopOpen(item,index,items){
		resetInstashopData()

		items.forEach(element => {
			const elementId = element.id;
			const elementImages = element?.images?.[0]?.imagemaps || [];
			const idsArray = [];

			if(elementImages?.length){
				elementImages.forEach(instashopPoint => {
					const instashopPointId = instashopPoint.id;
					idsArray.push(instashopPointId);
				});
			}
			
			element.instashopIds = idsArray;
		});
		
		
		instashopData.value.instashopActive = true,
		instashopData.value.instashopItemIndex = index,
		instashopData.value.items.push(...items)
	}
</script>


<style lang="less" scoped>
	.ip{
		width: auto; height: auto; aspect-ratio: 1 / 1; display: flex; align-items: center; justify-content: center;
		span{display: block;}
		:deep(img){width: auto; height: auto; aspect-ratio: 1/1; display: block;}
	}
	.ip:nth-child(9n + 1),
	.ip:nth-child(9n + 2),
	.ip:nth-child(9n + 3) {
		width: calc((100% - 2 * 21px) / 3);
		@media (max-width: @t){width: calc((100% - 2 * 15px) / 3);}
		@media (max-width: @tp){width: 100%;}
	}

	.ip:nth-child(9n + 4),
	.ip:nth-child(9n + 5),
	.ip:nth-child(9n + 6),
	.ip:nth-child(9n + 7) {
		width: calc((100% - 3 * 21px) / 4);
		@media (max-width: @t){width: calc((100% - 3 * 15px) / 4);}
		@media (max-width: @tp){width: calc((100% - 2 * 4px) / 2);}
	}

	.ip:nth-child(9n + 8),
	.ip:nth-child(9n + 9) {
		width: calc((100% - 1 * 21px) / 2);
		@media (max-width: @t){width: calc((100% - 1 * 15px) / 2);}
		@media (max-width: @tp){width: 100%;}
	}
</style>